import React from "react";
import banner from "../../asset/About Management banner.png";
import { IoMdMail } from "react-icons/io";
import { useGetAllProfilesPublicQuery } from "../../Redux/getApi";
import noImage from "../../asset/no image.png";
import { TeamCardSkeleton } from "../../Pages/About us/AboutUs";

const AboutManagement = () => {
  const { data, isLoading, isFetching } = useGetAllProfilesPublicQuery();

  const grouped = data?.groupedProfiles || {};
  const postCategories = data?.postCategories || [];

  const allProfilesEmpty = Object.values(grouped).every(
    (profiles) => !profiles || profiles.length === 0
  );

  return (
    <div className="flex flex-col gap-10 mb-20 xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%]">
      {/* Banner */}
      <div className="xl:py-6 lg:py-4 py-3">
        <img
          src={banner}
          alt="About Management"
          className="lg:rounded-2xl w-full rounded-xl"
        />
      </div>

      {/* About Management Title */}
      <div className="flex flex-col items-center gap-10 mt-10 text-center">
        <div>
          <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] font-bold">
            About Management
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#5A5A5A]">
            Discover the organizational structure of Rawalpindi Development
            Authority
          </p>
        </div>
      </div>

      {/* Render categories dynamically */}
      {allProfilesEmpty && !isFetching && !isLoading ? (
        <NotFound />
      ) : (
        postCategories.map((category, idx) => {
          const profiles = grouped[category] || [];

          return (
            <div key={idx} className="flex flex-col items-center gap-10 mt-10">
              {isFetching || isLoading ? (
                <div className="w-[12rem] h-8 rounded-xl animate-pulse bg-gray-200"></div>
              ) : category !== "General Director" ? (
                <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] font-bold text-center">
                  {category}s
                </h1>
              ) : null}

              <div className="flex items-stretch justify-center flex-wrap gap-6 lg:w-[90%] w-[95%] max-w-5xl mx-auto ">
                {isFetching || isLoading ? (
                  <TeamCardSkeleton items={3} />
                ) : (
                  profiles.map((profile, i) => (
                    <div
                      key={i}
                      className="w-full max-w-xs bg-[#DEE9E4] group hover:bg-[#00643b] p-6 rounded-2xl transition-all duration-300"
                    >
                      <img
                        src={profile?.profileImage?.imageUrl || noImage}
                        className="rounded-xl w-full aspect-[1/1.2] object-cover"
                        alt={profile?.fullName || "Profile"}
                      />

                      <div className="mt-8 text-center relative">
                        {profile?.email && (
                          <a
                            href={`mailto:${profile.email}`}
                            className="absolute bg-[#00643b] group-hover:bg-[#fff] py-1.5 px-5 rounded-full text-white group-hover:text-[#00643b] top-[-48px] left-1/2 transform -translate-x-1/2 transition-all duration-300"
                          >
                            <IoMdMail className="size-5" />
                          </a>
                        )}

                        <h1 className="text-[1.1rem] font-semibold group-hover:text-[#fff]">
                          {profile.fullName}
                        </h1>
                        <p className="text-[.9rem] text-[#343434] font-semibold group-hover:text-[#fff]">
                          {profile.position}
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export const NotFound = () => {
  return (
    <div className=" w-full text-center lg:text-[3rem] text-[2.5rem] font-bold">
      No profiles found.
    </div>
  );
};

export default AboutManagement;

// import React from "react";
// import banner from "../../asset/About Management banner.png";
// import { NavLink } from "react-router-dom";
// import KinzaMurtazaImage from "../../asset/Kinza Murtaza.png";
// import AwaisManzoorTararImage from "../../asset/Awais Manzoor Tarar.png";
// import MuhammadAnwarBaranImage from "../../asset/Muhammad Anwar Baran.png";
// import AsifMahmoodImage from "../../asset/Asif Mahmood.png";
// import DirectorLUBCMPTEImage from "../../asset/Director LUBCMP&TE.png";
// import ShahzadGondalImage from "../../asset/Shahzad Gondal.png";
// import MuhammadKamranImage from "../../asset/Muhammad Kamran.png";
// import GhazanfarMalikImage from "../../asset/Ghazanfar Malik.png";
// import IftikharAliImage from "../../asset/Iftikhar Ali.png";
// import SamiullahKhanNiaziImage from "../../asset/Samiullah Khan Niazi.png";
// import AtifMehmoodChImage from "../../asset/Atif Mehmood Ch.png";
// import HafizMuhammadIrfanImage from "../../asset/Hafiz Muhammad Irfan.png";
// import DawoodKhalidImage from "../../asset/Dawood Khalid.png";
// import RajaWaqarAsgharImage from "../../asset/Raja Waqar Asghar.png";
// import WaqarAhmadImage from "../../asset/Waqar Ahmad.png";
// import MuhammadShoaibKhanImage from "../../asset/Muhammad Shoaib Khan.png";
// import MehwishNaseemImage from "../../asset/Mehwish Naseem.png";
// import AliRazaImage from "../../asset/Ali Raza.png";
// import ShizaTanweerImage from "../../asset/Shiza Tanweer.png";
// import SyedaRidaSultanImage from "../../asset/Syeda Rida Sultan.png";
// import MuhammadDaudImage from "../../asset/Muhammad Daud.png";
// import noImage from "../../asset/no image.png";
// import { IoMdMail } from "react-icons/io";
// import { useGetAllProfilesPublicQuery } from "../../Redux/getApi";

// const AboutManagement = () => {
//   const headCard = [
//     {
//       name: "Kinza Murtaza",
//       image: KinzaMurtazaImage,
//       link: "",
//       designation: "Director General RDA",
//     },
//     {
//       name: "Awais Manzoor Tarar",
//       image: AwaisManzoorTararImage,
//       link: "",
//       designation: "Additional Director General RDA",
//     },
//     {
//       name: "Muhammad Anwar Baran",
//       image: MuhammadAnwarBaranImage,
//       link: "",
//       designation: "Chief Engineer RDA",
//     },
//   ];

//   const DirectorsCard = [
//     {
//       name: "Asif Mahmood",
//       image: AsifMahmoodImage,
//       link: "",
//       designation: "Director Admn & Finance",
//     },
//     {
//       name: "Director LUBC/MP&TE",
//       image: DirectorLUBCMPTEImage,
//       link: "",
//       designation: "Director LUBC/MP&TE",
//     },
//     {
//       name: "Shahzad Gondal",
//       image: ShahzadGondalImage,
//       link: "",
//       designation: "Director Estate Management",
//     },
//     {
//       name: "Muhammad Anwar Baran",
//       image: MuhammadAnwarBaranImage,
//       link: "",
//       designation: "Director Engineering I",
//     },
//     {
//       name: "Muhammad Kamran",
//       image: MuhammadKamranImage,
//       link: "",
//       designation: "Director Engineering II",
//     },
//     {
//       name: "Ghazanfar Malik",
//       image: GhazanfarMalikImage,
//       link: "",
//       designation: "Director Land Development",
//     },
//     {
//       name: "Qazi Sohaib Ahmad",
//       image: noImage,
//       link: "",
//       designation: "Director Finance",
//     },
//   ];

//   const DeputyDirectorsCard = [
//     {
//       name: "Khawaja Arshad",
//       image: noImage,
//       link: "",
//       designation: "Deputy Director Finance",
//     },
//     {
//       name: "Iftikhar Ali",
//       image: IftikharAliImage,
//       link: "",
//       designation: "Deputy Director Admn",
//     },
//     {
//       name: "Samiullah Khan Niazi",
//       image: SamiullahKhanNiaziImage,
//       link: "",
//       designation: "Deputy Director Planning",
//     },
//     {
//       name: "Atif Mehmood Ch",
//       image: AtifMehmoodChImage,
//       link: "",
//       designation: "Deputy Director Building Control",
//     },

//     {
//       name: "Hafiz Muhammad Irfan",
//       image: HafizMuhammadIrfanImage,
//       link: "",
//       designation: "Deputy Director (PR)",
//     },
//     {
//       name: "Dawood Khalid",
//       image: DawoodKhalidImage,
//       link: "",
//       designation: "Deputy Director (IT)",
//     },
//     {
//       name: "Muhammad Kamran",
//       image: MuhammadKamranImage,
//       link: "",
//       designation: "Director Engineering II",
//     },
//   ];

//   const AssistantDirectorsCard = [
//     {
//       name: "Raja Waqar Asghar",
//       image: RajaWaqarAsgharImage,
//       link: "",
//       designation: "Assistant Director Land Development",
//     },
//     {
//       name: "Waqar Ahmad",
//       image: WaqarAhmadImage,
//       link: "",
//       designation: "Assistant Director General",
//     },
//     {
//       name: "Muhammad Shoaib Khan",
//       image: MuhammadShoaibKhanImage,
//       link: "",
//       designation: "Assistant Director Estate Management",
//     },
//     {
//       name: "Mehwish Naseem",
//       image: MehwishNaseemImage,
//       link: "",
//       designation: "Assistant Director Planning",
//     },

//     {
//       name: "Ali Raza",
//       image: AliRazaImage,
//       link: "",
//       designation: "Assistant Director Planning",
//     },
//     {
//       name: "Shiza Tanweer",
//       image: ShizaTanweerImage,
//       link: "",
//       designation: "Assistant Director Building Control",
//     },
//     {
//       name: "Syeda Rida Sultan",
//       image: SyedaRidaSultanImage,
//       link: "",
//       designation: "Assistant Director Architecture",
//     },
//     {
//       name: "Muhammad Daud",
//       image: MuhammadDaudImage,
//       link: "",
//       designation: "Assistant Director Traffic Engineering Planning",
//     },
//   ];
//   const { data, isLoading, isFetching } = useGetAllProfilesPublicQuery();
//   return (
//     <div className="flex flex-col gap-10  mb-20  xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%]">
//       <div className="xl:py-6 lg:py-4 py-3">
//         <img src={banner} alt="" className="lg:rounded-2xl w-full rounded-xl" />
//       </div>
//       {/* about management */}
//       <div className="flex flex-col items-center gap-10 mt-10">
//         <div>
//           <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] font-bold text-center">
//             About Management
//           </h1>
//           <p className="md:text-[1.3rem] text-[1rem]  text-center text-[#5A5A5A]">
//             Discover the organizational structure of Rawalpindi Development
//             Authority
//           </p>
//         </div>

//         <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 w-[90%] max-w-5xl mx-auto justify-items-center">
//           {headCard.map((head, i) => (
//             <div
//               key={i}
//               className="w-full bg-[#DEE9E4] group hover:bg-[#00643b] p-6 rounded-2xl "
//             >
//               <img src={head.image} className="rounded-xl w-full" alt="" />
//               <div className="mt-8 text-center relative">
//                 <NavLink className="absolute bg-[#00643b] group-hover:bg-[#fff] py-1.5 px-5 rounded-full text-white group-hover:text-[#00643b] top-[-48px] left-1/2 transform -translate-x-1/2">
//                   <IoMdMail className="size-5" />
//                 </NavLink>
//                 <h1 className="text-[1.1rem] font-semibold group-hover:text-[#fff]">
//                   {head.name}
//                 </h1>
//                 <p className="text-[.9rem] text-[#343434] font-semibold group-hover:text-[#fff]">
//                   {head.designation}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       {/* Directors */}
//       <div className="flex flex-col items-center gap-10 mt-10">
//         <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] font-bold text-center">
//           Directors
//         </h1>

//         <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 w-[90%] max-w-5xl mx-auto justify-items-center">
//           {DirectorsCard.map((dc, i) => (
//             <div
//               key={i}
//               className="w-full bg-[#DEE9E4] group hover:bg-[#00643b] p-6 rounded-2xl "
//             >
//               <img src={dc.image} className="rounded-xl w-full" alt="" />
//               <div className="mt-8 text-center relative">
//                 <NavLink className="absolute bg-[#00643b] group-hover:bg-[#fff] py-1.5 px-5 rounded-full text-white group-hover:text-[#00643b] top-[-48px] left-1/2 transform -translate-x-1/2">
//                   <IoMdMail className="size-5" />
//                 </NavLink>
//                 <h1 className="text-[1.1rem] font-semibold group-hover:text-[#fff]">
//                   {dc.name}
//                 </h1>
//                 <p className="text-[.9rem] text-[#343434] group-hover:text-[#fff] font-semibold">
//                   {dc.designation}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       {/* Deputy Directors */}
//       <div className="flex flex-col items-center gap-10 mt-10">
//         <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] font-bold text-center">
//           Deputy Directors
//         </h1>

//         <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 w-[90%] max-w-5xl mx-auto justify-items-center">
//           {DeputyDirectorsCard.map((ddc, i) => (
//             <div
//               key={i}
//               className="w-full bg-[#DEE9E4] group hover:bg-[#00643b] p-6 rounded-2xl "
//             >
//               <img src={ddc.image} className="rounded-xl w-full" alt="" />
//               <div className="mt-8 text-center relative">
//                 <NavLink className="absolute bg-[#00643b] group-hover:bg-[#fff] py-1.5 px-5 rounded-full text-white group-hover:text-[#00643b] top-[-48px] left-1/2 transform -translate-x-1/2">
//                   <IoMdMail className="size-5" />
//                 </NavLink>
//                 <h1 className="text-[1.1rem] font-semibold group-hover:text-[#fff]">
//                   {ddc.name}
//                 </h1>
//                 <p className="text-[.9rem] text-[#343434] font-semibold group-hover:text-[#fff]">
//                   {ddc.designation}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       {/* Assistant Directors */}
//       <div className="flex flex-col items-center gap-10 mt-10">
//         <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] font-bold text-center">
//           Assistant Directors
//         </h1>

//         <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 w-[90%] max-w-5xl mx-auto justify-items-center">
//           {AssistantDirectorsCard.map((adc, i) => (
//             <div
//               key={i}
//               className="w-full bg-[#DEE9E4] group hover:bg-[#00643b] p-6 rounded-2xl "
//             >
//               <img src={adc.image} className="rounded-xl w-full" alt="" />
//               <div className="mt-8 text-center relative">
//                 <NavLink className="absolute bg-[#00643b] group-hover:bg-[#fff] py-1.5 px-5 rounded-full text-white group-hover:text-[#00643b] top-[-48px] left-1/2 transform -translate-x-1/2">
//                   <IoMdMail className="size-5" />
//                 </NavLink>
//                 <h1 className="text-[1.1rem] font-semibold group-hover:text-[#fff]">
//                   {adc.name}
//                 </h1>
//                 <p className="text-[.9rem] text-[#343434] font-semibold group-hover:text-[#fff]">
//                   {adc.designation}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutManagement;
